import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Paper, Box, Avatar, Typography, Grid, Link } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as EditIcon } from '../../../../assets/images/edit.svg';
import { ReactComponent as KeyIcon } from '../../../../assets/images/key.svg';
import { ReactComponent as RequestSuccessIcon } from '../../../../assets/images/request-success.svg';
import { CustomButton } from '../../../../components/CustomButton';
import { ChangePasswordDialog } from '../../components/ChangePasswordDialog';
import { CustomModal } from '../../../../components/CustomModal';
import { ROUTES, ROUTE_FOR_ASSETS } from '../../../../constants/routes';
import { getListRoles } from '../../../../store/role/actions';
import { serviceRoles } from '../../../../utils/serviceRoles';

export const Profile = () => {
  const dispatch = useDispatch();

  const [isChangePasswordModal, setIsChangePasswordModal] = useState(false);
  const [isSuccessModal, setIsSuccessModal] = useState(false);

  const { userData: userInfo } = useSelector((state) => state.currentUser);


  useEffect(() => {
    dispatch(getListRoles());
  }, [dispatch, userInfo]);

  return (
    <>
      <Paper
        sx={{
          padding: '32px',
          marginBottom: '16px'
        }}>
        <Box
          sx={{
            display: 'flex'
          }}>
          <Avatar
            alt={`${userInfo?.firstName} ${userInfo?.lastName}`}
            src={`${ROUTE_FOR_ASSETS}${userInfo.avatar}`}
            sx={{ width: 128, height: 128, marginRight: '32px' }}
          />

          <Box
            sx={{
              width: '100%',
              display: 'flex'
            }}>
            <Box
              sx={{
                width: '100%',
                maxWidth: '370px',
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="h1" mb="8px">
                {userInfo?.firstName} {userInfo?.lastName} {userInfo?.middleName}
              </Typography>
              <Typography variant="subtitle2" component="p" mb="24px">
                {serviceRoles(userInfo?.role?.id).label}
              </Typography>
              <Box sx={{ display: 'flex' }}>
                <Box>
                  <CustomButton
                    color="secondary"
                    variant="outlined"
                    size="small"
                    sx={{ marginRight: '16px' }}
                    startIcon={<EditIcon />}
                    component={RouterLink}
                    to={ROUTES.EDIT_PROFILE}
                  >
                    Редактировать
                  </CustomButton>
                </Box>
                <CustomButton
                  color="secondary"
                  variant="outlined"
                  size="small"
                  startIcon={<KeyIcon />}
                  onClick={() => setIsChangePasswordModal(true)}
                >
                  Сменить пароль
                </CustomButton>
              </Box>
            </Box>
            <Box
              sx={{
                width: '100%',
                textAlign: 'end'
              }}>
              <Typography
                component="span"
                color="success.main"
                variant="subtitle2"
                sx={{
                  fontWeight: 500
                }}>
                {userInfo?.status}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
      <Paper
        sx={{
          padding: '24px'
        }}>
        <Grid container>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Номер телефона
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500
                }}
                data-testid="PhoneNumber"
              >
                {userInfo?.phone && `+7 ${userInfo?.phone}`}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Email
              </Typography>
              <Link
                href="mailto:myemail@gmail.com"
                variant="subtitle2"
                color="primary.main"
                underline="hover"
                sx={{
                  fontWeight: 500
                }}>
                {userInfo?.email}
              </Link>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Филиал
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500
                }}>
                {userInfo?.branch?.name}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}>
              <Typography variant="body1" color="text.secondary">
                Департамент
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500
                }}>
                {userInfo?.department?.name}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <ChangePasswordDialog
        opened={isChangePasswordModal}
        modalClose={() => setIsChangePasswordModal(false)}
        handleSecondModal={() => setIsSuccessModal(true)}
        data-testid="ChangePasswordModal"
      />
      <CustomModal
        opened={isSuccessModal}
        modalClose={() => setIsSuccessModal(false)}
        modalSubmit={() => setIsSuccessModal(false)}
        text="Пароль изменен успешно"
        submitBtnName="Готово"
        icon={
          <>
            <RequestSuccessIcon />
          </>
        }
      />
    </>
  );
};
